import type { CustomField, PriceGroup, Ticket, TicketLocalizationCheckoutData, UpsaleAvailableTicket, VolumeDiscount } from '@/types';

export interface CartTicketDTO {
  id: number | string;
  name1: string;
  count: number;
  price: number;
  min_price: number;
  max_price: number;
  price_groups: PriceGroup[];
  vd_price: number;
  vd_min_price: number;
  vd_max_price: number;
  vd_price_groups: PriceGroup[];
  volume_discount: VolumeDiscount[] | undefined;
  ticketfee: number;
  ticketfee_extra: number;
  hide_ticketfee_extra: number;
  shippingfee: number;
  payment_only_dankort: number;
  is_mobile_pay_okay: number;
  sso_price_warning: number;
  upsale_flag: number;
  upsale_name: string;
  upsale_title: string;
  upsale_description: string;
  upsale_allowed_tickets: number[];
  upsale_banned_tickets: number[];
  upsale_available_tickets: UpsaleAvailableTicket[];
  beforePrice?: number;
  currency: string;
  discountText?: string;
  description?: string;
  flexData?: string[];
  customFields?: CustomField[];
  localizations: TicketLocalizationCheckoutData;
  label?: string;
  activationCode?: string;
  tags?: string[];
}

export function mapDtoToTicket(dto: CartTicketDTO): Ticket {
  return {
    ...dto,
    id: Number(dto.id),
    count: Number(dto.count) || 0,
    price: Number(dto.price) || 0,
    min_price: Number(dto.min_price) || 0,
    max_price: Number(dto.max_price) || 0,
    vd_price: Number(dto.vd_price) || 0,
    vd_min_price: Number(dto.vd_min_price) || 0,
    vd_max_price: Number(dto.vd_max_price) || 0,
    ticketfee: Number(dto.ticketfee) || 0,
    ticketfee_extra: Number(dto.ticketfee_extra) || 0,
    shippingfee: Number(dto.shippingfee) || 0,
    hide_ticketfee_extra: Boolean(dto.hide_ticketfee_extra),
    is_mobile_pay_okay: Boolean(dto.is_mobile_pay_okay),
    upsale_flag: Boolean(dto.upsale_flag),
    sso_price_warning: dto.sso_price_warning ? String(dto.sso_price_warning) : null,
  };
}
